<!-- FORMULARIO SOBRE TI -->
<p class="text-form">Solamente los campos marcados con (*) son obligatorios.</p>
<form action="" autocomplete="off" class="form" [formGroup]="formStepAboutYou">
  <!-- EXPECTATIVA SALARIAL -->
  <mat-form-field appearance="fill">
    <mat-label>Expectativa salarial mensual</mat-label>
    <input
      appNumber
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese expectativa salarial mensual"
      formControlName="salaryExpectation"
      appBlockCopyPasteInput
      matTooltip="El máximo salario que se puede recibir por mes como Conductor Vemo es de 15000 pesos mexicanos. Si ingresa mas de ese valor no podremos cumplir sus expectativas."
    />
    <mat-error
      *ngIf="
        formStepAboutYou.controls['salaryExpectation'].invalid &&
        formStepAboutYou.controls['salaryExpectation'].touched
      "
    >
      <span
        *ngIf="
          formStepAboutYou.controls['salaryExpectation'].errors &&
          formStepAboutYou.controls['salaryExpectation'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepAboutYou.controls['salaryExpectation'].hasError('maxlength')
      "
      >Máximo 7 caracteres.
    </mat-error>
    <mat-icon matSuffix>notification_important</mat-icon>
  </mat-form-field>
  <!-- LICENCIA VIGENTE -->
  <div>
    <mat-label>¿Tienes licencia vigente que no sea de Guerrero? *</mat-label>
    <div>
      <mat-radio-group
        (change)="checkEvent()"
        aria-label="Seleccione una opción"
        formControlName="hasGuerreroLicense"
      >
        <mat-radio-button [value]="false" class="margin-radio-button"
          >Si</mat-radio-button
        >
        <mat-radio-button [value]="true">No </mat-radio-button>
        <mat-error
          *ngIf="
            formStepAboutYou.controls['hasGuerreroLicense'].invalid &&
            formStepAboutYou.controls['hasGuerreroLicense'].touched
          "
        >
          <span
            *ngIf="
              formStepAboutYou.controls['hasGuerreroLicense'].errors &&
              formStepAboutYou.controls['hasGuerreroLicense'].errors['required']
            "
            >Debe seleccionar una opción</span
          >
        </mat-error>
      </mat-radio-group>
    </div>
  </div>
  <!-- DISPONIBILIDAD PARA TRABAJAR -->
  <div>
    <mat-label>¿Cúal es tu disponibilidad para trabajar? *</mat-label>
    <div>
      <mat-radio-group
        (change)="checkEvent()"
        aria-label="Seleccione una opción"
        formControlName="canFullTime"
      >
        <mat-radio-button [value]="true" class="margin-radio-button"
          >Turno completo</mat-radio-button
        >
        <mat-radio-button [value]="false">Medio turno </mat-radio-button>
        <mat-error
          *ngIf="
            formStepAboutYou.controls['canFullTime'].invalid &&
            formStepAboutYou.controls['canFullTime'].touched
          "
        >
          <span
            *ngIf="
              formStepAboutYou.controls['canFullTime'].errors &&
              formStepAboutYou.controls['canFullTime'].errors['required']
            "
            >Debe seleccionar una opción</span
          >
        </mat-error>
      </mat-radio-group>
    </div>
  </div>
  <!-- UBER BLOQUEADO  -->
  <div>
    <mat-label>¿Estas bloqueado en Uber? *</mat-label>
    <div>
      <mat-radio-group
        (change)="checkEvent()"
        aria-label="Seleccione una opción"
        formControlName="hasUberBlocked"
      >
        <mat-radio-button [value]="true" class="margin-radio-button"
          >Si</mat-radio-button
        >
        <mat-radio-button [value]="false">No </mat-radio-button>
        <mat-error
          *ngIf="
            formStepAboutYou.controls['hasUberBlocked'].invalid &&
            formStepAboutYou.controls['hasUberBlocked'].touched
          "
        >
          <span
            *ngIf="
              formStepAboutYou.controls['hasUberBlocked'].errors &&
              formStepAboutYou.controls['hasUberBlocked'].errors['required']
            "
            >Debe seleccionar una opción</span
          >
        </mat-error>
      </mat-radio-group>
    </div>
  </div>
  <!-- VIVES EN CDMX O METROPOLITANA -->
  <div>
    <mat-label>¿Vives en la CDMX o su zona metropolitana? *</mat-label>
    <div>
      <mat-radio-group
        (change)="checkEvent()"
        aria-label="Seleccione una opción"
        formControlName="liveCdmxOrMetropolitana"
      >
        <mat-radio-button [value]="true" class="margin-radio-button"
          >Si</mat-radio-button
        >
        <mat-radio-button [value]="false">No </mat-radio-button>
        <mat-error
          *ngIf="
            formStepAboutYou.controls['liveCdmxOrMetropolitana'].invalid &&
            formStepAboutYou.controls['liveCdmxOrMetropolitana'].touched
          "
        >
          <span
            *ngIf="
              formStepAboutYou.controls['liveCdmxOrMetropolitana'].errors &&
              formStepAboutYou.controls['liveCdmxOrMetropolitana'].errors[
                'required'
              ]
            "
            >Debe seleccionar una opción</span
          >
        </mat-error>
      </mat-radio-group>
    </div>
  </div>
  <div>
    <!-- DISPONIBLIDAD TURNO NOCHE -->
    <mat-label>
      ¿Tienes disponibilidad e interés para realizar turnos nocturnos? *
    </mat-label>
    <div>
      <mat-radio-group
        aria-label="Seleccione una opción"
        formControlName="hasNightAvailability"
        (change)="checkEvent()"
      >
        <mat-radio-button [value]="true" class="margin-radio-button">
          Si
        </mat-radio-button>
        <mat-radio-button [value]="false"> No </mat-radio-button>
        <mat-error
          *ngIf="
            formStepAboutYou.controls['hasNightAvailability'].invalid &&
            formStepAboutYou.controls['hasNightAvailability'].touched
          "
        >
          <span
            *ngIf="
              formStepAboutYou.controls['hasNightAvailability'].errors &&
              formStepAboutYou.controls['hasNightAvailability'].errors[
                'required'
              ]
            "
          >
            Debe seleccionar una opción
          </span>
        </mat-error>
      </mat-radio-group>
    </div>
  </div>
</form>
